import { defineStore } from "pinia";
import { ref, watch } from "vue";
import type CityInterface from "../interfaces/CityInterface";
import { useDirectusStore } from "@/modules/directus/store/directus";
import { readItems } from "@directus/sdk";
import { useIonRouter } from "@ionic/vue";

export const useCityStore = defineStore("city", () => {
  const city = ref<CityInterface | null>(null);

  const directus = useDirectusStore();

  const router = useIonRouter();

  watch(
    () => city.value,
    (newCity) => {
      if (!newCity) {
        router.push({
          name: "cities",
        });
      }
    }
  );

  const getCitiesList = () => {
    return directus.main.request(readItems("cities"));
  };

  return {
    getCitiesList,
    city,
  };
});
